import { Component, Element, Host, Method, h } from '@stencil/core';

@Component({
  tag: 'sy-floated',
  shadow: true,
})
export class Floated {
  private listeners: { afterRemoved: () => void } | null;

  @Element() el: HTMLSyFloatedElement;

  /**
   * Add listeners.
   */
  @Method()
  async addListeners(listeners: { afterRemoved: () => void }): Promise<void> {
    this.listeners = listeners;
  }

  /**
   * Remove listeners
   */
  @Method()
  async removeListeners(): Promise<void> {
    this.listeners = null;
  }

  disconnectedCallback() {
    if (!this.el.isConnected) {
      const { afterRemoved } = this.listeners || {};
      afterRemoved?.();
    }
  }

  render() {
    return <Host></Host>;
  }
}
